import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormFieldConfig } from '../dropdown/form_field_config';
import { Language } from '../../../entities/language';
import { UserService } from 'src/app/admin/core/services/user.service';

@Component({
  selector: 'app-multi-langue',
  templateUrl: './multi-langue.component.html',
  styleUrls: ['./multi-langue.component.css'],
})
export class MultiLangueComponent implements OnInit {
  @Input() config: FormFieldConfig;
  @Input() data: any;
  @Input() languages: Language[];
  typeName: any;

  value: any = {};
  multilangueMap: { [key: string]: any } = {};

  constructor(public userService: UserService) { }

  ngOnInit(): void {
    this.setVisibility();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.config = changes['config'].currentValue;

      // Break reference to data object → prevents shared state
      if (this.config.value) {
        this.multilangueMap = JSON.parse(JSON.stringify(this.config.value));
      } else {
        this.multilangueMap = {};
      }

      this.typeName = this.config.typeName;
    }
  }


  setVisibility() {
    if (!this.config.isDynamic) {
      this.config.isVisible = true;
      this.config.isModifiable = true;
    }
  }

  isLocal(local: string): boolean {
    return (
      this.languages?.find((l) => l.key === local && l.selected) !== undefined
    );
  }

  onValueChange(langKey: string, event: any) {
    this.multilangueMap[langKey] = event.target.value;
    this.config.value = this.multilangueMap;
  }
}
